import { handleError } from "../../../../utils/helpers";
import {
  FinancialSummaryParams,
  FrequencyFilter,
  QueryParams,
} from "../../../../utils/types";
import { adminBaseApi } from "../../../api";
import {
  AdminFinancialSummary,
  AdminRevenueStatistics,
  AdminRevenueTable,
  PayoutCurrency,
  PayoutDetailsResponse,
  PayoutHistoryResponse,
  PurchaseStatisticsResponse,
} from "../../payment/payment.types";

export const adminUsersApi = adminBaseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    adminGetPurchaseStatistics: builder.query<
      PurchaseStatisticsResponse,
      { eventId: string; otherParams?: QueryParams }
    >({
      query: (params) => {
        return {
          url: `admin/events/summary/${params.eventId}`,
          method: "GET",
          params: params.otherParams,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminGetPayoutHistory: builder.query<
      PayoutHistoryResponse,
      { eventId: string; otherParams?: QueryParams }
    >({
      query: (params) => {
        return {
          url: `admin/events/${params.eventId}/payout-history`,
          method: "GET",
          params: params.otherParams,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminGetSinglePayoutDetails: builder.query<
      PayoutDetailsResponse,
      { id: string; payoutId?: string }
    >({
      query: ({ id, ...params }) => {
        return {
          url: `admin/events/${id}/payout-details`,
          method: "GET",
          params: {
            ...params,
          },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminGetRevenueStatistics: builder.query<
      AdminRevenueStatistics,
      { filter: FrequencyFilter; currency?: PayoutCurrency }
    >({
      query: (params) => {
        return {
          url: `admin/revenue-stats`,
          method: "GET",
          params: { ...params },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminGetRevenueTable: builder.query<AdminRevenueTable, QueryParams>({
      query: (params) => {
        return {
          url: `admin/revenue-data`,
          method: "GET",
          params: {},
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminFinancialSummary: builder.query<
      AdminFinancialSummary,
      FinancialSummaryParams
    >({
      query: ({ month, year, currency }) => {
        return {
          url: `admin/financial-summary`,
          method: "GET",
          params: {
            month,
            year,
            currency,
          },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
  }),
});

export const {
  useAdminGetPurchaseStatisticsQuery,
  useAdminGetPayoutHistoryQuery,
  useAdminGetSinglePayoutDetailsQuery,
  useAdminGetRevenueStatisticsQuery,
  useAdminGetRevenueTableQuery,
  useAdminFinancialSummaryQuery,
} = adminUsersApi;
